
export const MARGIN = 'margin'
export const CHARGE = 'charge'

export const PRICING_MODES = {
    COST_PLUS: {
        name: 'Cost-Plus',
        id: 1
    },
    CLIENT_PRICE: {
        name: 'Client-Price',
        id: 2
    }
}

export const COMPONENT_ORDER = {
    [PRICING_MODES.COST_PLUS.id]: [MARGIN, CHARGE],
    [PRICING_MODES.CLIENT_PRICE.id]: [CHARGE, MARGIN],
}